var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowNarrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7657 9.83441C11.9156 9.98443 11.9999 10.1879 11.9999 10.4C11.9999 10.6121 11.9156 10.8156 11.7657 10.9656L8.56566 14.1656C8.41564 14.3156 8.2122 14.3998 8.00006 14.3998C7.78793 14.3998 7.58449 14.3156 7.43447 14.1656L4.23447 10.9656C4.15806 10.8918 4.09711 10.8035 4.05518 10.7059C4.01326 10.6083 3.99119 10.5033 3.99026 10.3971C3.98934 10.2909 4.00958 10.1856 4.04981 10.0872C4.09003 9.98892 4.14943 9.8996 4.22455 9.82449C4.29966 9.74938 4.38898 9.68997 4.4873 9.64975C4.58562 9.60952 4.69096 9.58928 4.79719 9.5902C4.90341 9.59113 5.00839 9.6132 5.10599 9.65512C5.20359 9.69705 5.29187 9.758 5.36566 9.83441L7.20006 11.6688V2.40001C7.20006 2.18783 7.28435 1.98435 7.43438 1.83432C7.58441 1.68429 7.78789 1.60001 8.00006 1.60001C8.21224 1.60001 8.41572 1.68429 8.56575 1.83432C8.71578 1.98435 8.80007 2.18783 8.80007 2.40001V11.6688L10.6345 9.83441C10.7845 9.68443 10.9879 9.60018 11.2001 9.60018C11.4122 9.60018 11.6156 9.68443 11.7657 9.83441Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNarrowDown);
export default __webpack_public_path__ + "static/media/ArrowNarrowDown.862135d06c959144ddd7b9658702a716.svg";
export { ForwardRef as ReactComponent };